import type {ReactNode} from "react";

import {Card, Separator, Skeleton} from "@project/design-system-web";

export function OverviewPanelSkeleton({children}: {children: ReactNode}) {
  return (
    <Card className="flex h-full w-full flex-col" variant="default">
      {children}
    </Card>
  );
}

function Header({children}: {children: ReactNode}) {
  return (
    <>
      <Card.Header className="relative flex shrink-0 flex-row items-center gap-3 pr-12">
        {children}
      </Card.Header>
      <Separator variant="default" />
    </>
  );
}

function Content({children}: {children: ReactNode}) {
  return (
    <Card.Content className="flex flex-1 flex-col overflow-hidden p-0">
      <div className="flex-1 px-6 py-4">{children}</div>
    </Card.Content>
  );
}

function Field() {
  return (
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3 w-16 rounded-sm" />
      <Skeleton className="h-4 w-full rounded-md" />
    </div>
  );
}

function Footer({children}: {children: ReactNode}) {
  return (
    <>
      <Separator variant="default" />
      <Card.Footer className="flex w-full flex-col gap-2 px-6 py-4">{children}</Card.Footer>
    </>
  );
}

function FooterItem() {
  return (
    <div className="flex w-full items-center justify-between">
      <Skeleton className="h-3 w-24 rounded-sm" />
      <Skeleton className="h-4 w-32 rounded-md" />
    </div>
  );
}

OverviewPanelSkeleton.Header = Header;
OverviewPanelSkeleton.Content = Content;
OverviewPanelSkeleton.Field = Field;
OverviewPanelSkeleton.Footer = Footer;
OverviewPanelSkeleton.FooterItem = FooterItem;
